import ApolloClient from 'apollo-client';
import {ApolloLink} from 'apollo-link';
import {onError} from 'apollo-link-error';

import {createHttpLink} from 'apollo-link-http';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {WHITE_LISTED_PATHS} from 'utils/constants';

import {buildRequestHeaders, checkServerError, setTokenFromHeader} from './utils/ajax';
import {graphqlEndpoint} from './config';

const httpLink = createHttpLink({
    uri: graphqlEndpoint
});


const middlewareLink = new ApolloLink((operation, forward) => {
    operation.setContext({
        headers: buildRequestHeaders()
    });

    return forward(operation);
});

const afterwareLink = new ApolloLink((operation, forward) => {
    return forward(operation).map(response => {
        const context = operation.getContext();

        setTokenFromHeader(context.response);

        return response;
    });
});

const checkAuthentication = (errors) => {
    if (Array.isArray(errors)
        && errors.filter(error => error.error === 'NOT_AUTHENTICATED_ERROR').length > 0
        && !WHITE_LISTED_PATHS.includes(window.location.pathname)) {
        window.location = '/logout?redirect=' + window.location.pathname;
    }
};

const errorLink = onError(({networkError, graphQLErrors}) => {
    checkAuthentication(graphQLErrors);
    if (networkError) {
        checkServerError(networkError.response);
    }
});


const link = errorLink.concat(afterwareLink.concat(middlewareLink.concat(httpLink)));

const client = new ApolloClient({
    link: link,
    cache: new InMemoryCache()
});

export default client;


export const refetchQueries = (queries) => {
    /**
     * The Apollo client can refetch queries based on name.
     * The query name is in the Query-object.
     * To see "loading" for the component, make sure that {notifyOnNetworkStatusChange: true} for the settings.
     * Every method returns a new promise
     */
    let i,
        ii,
        query,
        queryName;

    query = queries[0];
    queryName = query.definitions[0].name.value;
    let promise = client.queryManager.refetchQueryByName(queryName);

    for (i = 1, ii = queries.length; i < ii; i++) {
        query = queries[i];
        queryName = query.definitions[0].name.value;
        promise = promise.then(client.queryManager.refetchQueryByName(queryName));
    }

    return promise;
};


export const refetchQuery = (query) => {
    refetchQueries([query]);
};

